import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PRODUCTS, SITE } from '../content';
import { RevealDirective } from '../reveal.directive';

@Component({
  selector: 'app-products',
  imports: [RevealDirective],
  templateUrl: './products.html',
  styleUrl: './products.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Products {
  protected readonly products = PRODUCTS;
  protected readonly stars = [1, 2, 3, 4, 5];
  protected readonly allHref = `${SITE}/living-room-recliners`;
}
